import { render, staticRenderFns } from "./_ProductCount.vue?vue&type=template&id=70c3031b"
import script from "./_ProductCount.vue?vue&type=script&lang=js"
export * from "./_ProductCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports